import { Button, Col, Layout, Menu, MenuProps, Row, theme } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveData } from "src/appRedux/reducers/commonDataReducer";
import UserInfo from "src/routes/UserInfo";
import {
  createMenuItems,
  getLocalStorage,
  removeLocalStorage
} from "src/util/Commom";

import {
  MenuOutlined,
  SettingOutlined,
  DownOutlined,
  BarChartOutlined,
  VideoCameraOutlined,
  FileImageOutlined,
  BookOutlined
} from "@ant-design/icons";

import { checkVaiTroMenu } from "../../util/Commom";

const { Header } = Layout;

interface listVaiTroAfter {
  isAdmin: boolean;
  listVaiTro: any[];
  isCollapsed: any;
  onClickOpenDrawer: any;
  windowSize: number;
  setPathName: any;
  menuSiderBar: any;
}

const HeaderAdmin: React.FC<listVaiTroAfter> = ({
  isAdmin,
  listVaiTro,
  isCollapsed,
  onClickOpenDrawer,
  windowSize,
  setPathName,
  menuSiderBar
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    token: { colorBgContainer }
  } = theme.useToken();
  const [activeHeader, setActiveHeader] = useState("");
  const idNhomTuLieu =
    menuSiderBar && menuSiderBar.length > 0 ? menuSiderBar[0].id : undefined;
  useEffect(() => {
    const path = location.pathname.split("/")[1];
    setActiveHeader(path);
    setPathName(location.pathname.slice(1));
  }, [location, idNhomTuLieu]);

  const onClick: MenuProps["onClick"] = (e) => {
    if (e.key === "video" || e.key === "hinh-anh" || e.key === "tu-lieu") {
      navigate(`/${e.key}/idnhomtulieu/${idNhomTuLieu}`);
    }
    if (e.key === "thong-ke") {
      navigate(`/${e.key}/theo-nguoi-nhap`);
    }
    if (e.key === "quan-tri") {
      navigate(`/${e.key}/quyen`);
    }
    setPathName(e.key);
    dispatch(
      saveData({
        dataSetName: "collapsed",
        data: false
      })
    );
  };

  const filteredItems = createMenuItems([
    {
      key: `tu-lieu`,
      icon: <BookOutlined />,
      label: "Tư liệu",
      hienthi: checkVaiTroMenu(
        ["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"],
        listVaiTro,
        isAdmin
      )
    },
    {
      key: `hinh-anh`,
      icon: <FileImageOutlined />,
      label: "Hình ảnh",
      hienthi: checkVaiTroMenu(
        ["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"],
        listVaiTro,
        isAdmin
      )
    },
    {
      key: `video`,
      icon: <VideoCameraOutlined />,
      label: "Video",
      hienthi: checkVaiTroMenu(
        ["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"],
        listVaiTro,
        isAdmin
      )
    },
    {
      key: "thong-ke",
      icon: <BarChartOutlined />,
      label: "Thống kê",
      hienthi: checkVaiTroMenu(
        ["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"],
        listVaiTro,
        isAdmin
      )
    },
    {
      key: "quan-tri",
      icon: <SettingOutlined />,
      label: "Quản trị",
      hienthi: checkVaiTroMenu(["ADMIN", "DUYET_XUAT_BAN"], listVaiTro, isAdmin)
    }
  ]);
  const onSelect = () => {
    if (getLocalStorage("dataFilter")) removeLocalStorage("dataFilter");
  };
  return (
    <Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        padding: 0,
        border: "none",
        height: 50
      }}
    >
      <Row
        align="middle"
        justify="space-between"
        style={{ width: "100%", background: colorBgContainer }}
        typeof="flex"
      >
        {!(isCollapsed && windowSize < 992) ? (
          ""
        ) : (
          <Col sm={3} xs={4}>
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={onClickOpenDrawer}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64
              }}
            />
          </Col>
        )}
        <Col
          lg={19}
          sm={15}
          xs={12}
          style={{ marginBottom: "auto", marginTop: "auto" }}
        >
          <Menu
            mode="horizontal"
            items={filteredItems}
            style={{ flex: 1, border: "none" }}
            overflowedIndicator={
              <span style={{ textAlign: "center" }}>
                <DownOutlined style={{ marginRight: 3, textAlign: "center" }} />
                Thêm
              </span>
            }
            onClick={onClick}
            onSelect={onSelect}
            selectedKeys={[activeHeader]}
          />
        </Col>
        <Col lg={5} sm={6} xs={8} typeof="flex">
          <Row style={{ flex: 1 }} justify="end">
            <UserInfo windowSize={windowSize} />
          </Row>
        </Col>
      </Row>
    </Header>
  );
};
export default HeaderAdmin;
